import { AbstractControl, ValidatorFn } from '@angular/forms';

/**
 *
 * @param {string} format The format to check the domain against.
 * Prefix with ! to blacklist
 * Separate multiple domains with |
 * @returns {Object|null} error Null if the format is valid
 * @returns {boolean} error.invalidFormat True if the format is invalid
 */
export function emailFormatValidator(format: string): ValidatorFn {
	return (control: AbstractControl) => {
		const err = { invalidFormat: true };

		if (!control.value || !control.value.includes('@')) {
			return null;
		}

		// If there is a ! in front, we are blacklisting
		const isBlacklist = format.charAt(0) === '!';

		const formatHaystack = format.split('|');
		const currentDomain = control.value.split('@')[1].toLowerCase();
		const isInHaystack = formatHaystack.find(str => str.toLowerCase().endsWith(`@${currentDomain}`));

		if (isBlacklist) {
			return isInHaystack ? err : null;
		}

		// Error if it is whitelisted and we did not find it
		return isInHaystack ? null : err;
	};
}
